// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"c9267289","698":"5b2eaf91","732":"1729a4be"}[chunkId] + ".css";
};